export const DEFAULT_SEARCH_PAGE_SIZE = 24;
